module.exports = __webpack_public_path__ + "img/product20-hangye.8d3ec2be.svg";